// src/hooks/useRequireNoAuth.ts
import { useEffect } from 'react';
import { useLocation, useRouter } from '@tanstack/react-router';
import { useAuthStore } from '@/stores/authStore';
import { RedirectToStruct } from '@/features/auth/utils';


export const useRequireNoAuth = () => {
  const router = useRouter();
  const { accessToken } = useAuthStore((state) => state.auth)
  const location = useLocation().search as RedirectToStruct;

  useEffect(() => {
    if (accessToken) {
      if(location.redirectTo) {
        router.history.replace(`/?redirectTo=${location.redirectTo}`)
      } else {
        router.history.replace('/');
      }
    }
  }, [accessToken, router.history]);
};